import type { FC } from 'react';
import Box from '@mui/material/Box';
import { gototestFiltersValidator } from '../validation';
import { FormProvider, useForm } from 'react-hook-form';
import type { z } from 'zod';
import { SelectApplications } from 'components/common';
import { useListParams } from 'hooks';
import GoToTestGrid from './GoToTestGrid';

type FormData = z.infer<typeof gototestFiltersValidator.schema>;

const GoToTest: FC = () => {
  const { apps } = useListParams();

  const formMethod = useForm<FormData>({
    resolver: gototestFiltersValidator.resolver,
    defaultValues: {
      apps: apps ? (apps as string[]) : undefined,
    },
  });

  return (
    <FormProvider {...formMethod}>
      <Box
        sx={{
          display: 'flex',
          width: '100%',
          height: '100%',
          flexDirection: 'column',
          pt: 1,
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flex: 1,
            width: '100%',
            height: '100%',
            position: 'relative',
            flexDirection: 'column',
            gap: 2,
          }}
        >
          <Box
            sx={{
              display: 'flex',
              width: '100%',
              flexDirection: 'row',
              gap: 2,
            }}
          >
            <Box sx={{ flex: 1, maxWidth: '400px' }}>
              <SelectApplications name={'apps'} inputLabel={'Apps'} multiples />
            </Box>
          </Box>
          <Box
            sx={{
              display: 'flex',
              flex: 1,
              width: '100%',
              height: '100%',
              position: 'relative',
              flexDirection: 'column',
            }}
          >
            <Box
              sx={{
                position: 'absolute',
                width: '100%',
                height: '100%',
              }}
            >
              <GoToTestGrid />
            </Box>
          </Box>
        </Box>
      </Box>
    </FormProvider>
  );
};

export default GoToTest;
